import React, { useState, useEffect, useContext } from "react";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../auth/config";
import SideButton from "./SideButton";
import Header from "./Header";
import {
  Box,
  Typography,
  CssBaseline,
  AppBar,
  Toolbar,
  Button,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { lime, blueGrey } from "@mui/material/colors";
import AuthContext from "../../auth/Auth-context";
import { useNavigate } from "react-router-dom";

const drawerWidth = 270;
const theme = createTheme({
  palette: {
    primary: lime,
    secondary: blueGrey,
  },
});

const siteOptions = [
  "Searcholl", "yrr_mynewtab", "yrr_wundrfly", "lukkol", "Mynewtab", "wundrfly", "ollreview",
  "vayutab", "searchhello", "safesearchengine", "Lukall", "speedytest",
  "safesearchengine_net", "safesearchengine_org", "taskticks", "amazeai",
];

function InviteUsers() {
  const navigate = useNavigate();
  const inviteUserCollection = collection(db, "inviteUsers");

  const [emailId, setEmailId] = useState("");
  const [permissionValue, setPermissionValue] = useState("");
  const [permissionID, setPermissionID] = useState("");
  const [sitePermission, setSitePermission] = useState([]);
  const [onloadData, setOnloadData] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [updateID, setUpdateID] = useState("");

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (authCtx.email) {
      getOnloadList();
    }
  }, [authCtx.email]);

  const getOnloadList = async () => {
    const data = await getDocs(inviteUserCollection);
    const list = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    console.log(list)
    setOnloadData(list);
  };

  const handlePermissionLevel = (e) => {
    setPermissionValue(e.target.value);
    setPermissionID(e.target.id);

    if (e.target.value === "Full Access") {
      setSitePermission([]);
      setSitePermission(siteOptions);

      siteOptions.forEach((site) => {
        const el = document.getElementById(site);
        if (el) el.checked = true;
      }); 
    } 
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSitePermission((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };


  console.log("sitePermission", sitePermission);

  
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmailId(value);

    if (value.includes("@")) {
      const inputPrefix = value.toLowerCase().split('@')[0];
      const existingUser = onloadData.find((user) => {
        const userPrefix = user.EmailId.toLowerCase().split('@')[0];
        return userPrefix === inputPrefix;
      });
      console.log(existingUser);
      if (existingUser) {
        setEmailId(existingUser.EmailId);
        setPermissionValue(existingUser.Level);
        setPermissionID(existingUser.SelectedID);
        setSitePermission(existingUser.SitePermission || []);
        setIsUpdateMode(true);
        setUpdateID(existingUser.id);

        setTimeout(() => {
          existingUser.SitePermission?.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.checked = true;
          });
          const radio = document.getElementById(existingUser.SelectedID);
          if (radio) radio.checked = true;
          document.getElementById("userID").disabled = true;
        }, 50);
      }
    } else {
      resetAllCheckboxes();
    }
  };

  const resetAllCheckboxes = () => {
    document.querySelectorAll(".btn-check").forEach((el) => (el.checked = false));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!permissionValue || !emailId) {
      alert("Please fill all fields.");
      return;
    }

    const userExists = onloadData.some((item) => item.EmailId === emailId);
    if (userExists) {
      alert("User already exists.");
      return;
    }

    await addDoc(inviteUserCollection, {
      EmailId: emailId,
      Level: permissionValue,
      SelectedID: permissionID,
      SitePermission: sitePermission,
    });

    alert("Access Granted Successfully");
    getOnloadList();
    clearForm();
  };

  const handleUpdate = async () => {
    if (!updateID) return;

    const userDoc = doc(inviteUserCollection, updateID);
    await updateDoc(userDoc, {
      EmailId: emailId,
      Level: permissionValue,
      SelectedID: permissionID,
      SitePermission: sitePermission,
    });

    alert("Updated Successfully");
    getOnloadList();
    clearForm();
  };

  const clearForm = () => {
    setEmailId("");
    setPermissionValue("");
    setPermissionID("");
    setSitePermission([]);
    setIsUpdateMode(false);
    setUpdateID("");
    document.getElementById("userID").disabled = false;
    resetAllCheckboxes();
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
      >
        <Toolbar sx={{ background: "#fff" }}>
          <Typography sx={{ color: "#333", fontWeight: "bold" }} variant="h6" noWrap>
            Analytics Tool
          </Typography>
          <Header />
        </Toolbar>
      </AppBar>
      <SideButton />
      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: "background.default" }}>
        <Toolbar />
        <div className="container pt-1">
          <Typography variant="h6"><b>Invite Users</b></Typography>
          <input
            id="userID"
            className="form-control"
            type="email"
            placeholder="Email ID"
            value={emailId}
            onChange={handleEmailChange}
          />
          <div className="PermsionLevel mt-3">
            <Typography variant="subtitle1"><b>Permission Level</b></Typography>
            <div className="btn-group mt-2" role="group">
              {["Restricted Access", "Full Access"].map((label, idx) => {
                const id = `btnradio${idx + 1}`;
                return (
                  <React.Fragment key={id}>
                    <input
                      type="radio"
                      onClick={handlePermissionLevel}
                      value={label}
                      className="btn-check"
                      name="btnradio"
                      id={id}
                      autoComplete="off"
                    />
                    <label className="btn btn-outline-primary" htmlFor={id}>
                      {label}
                    </label>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          <div className="PermsionLevel mt-3">
            <Typography variant="subtitle1"><b>Site Permissions</b></Typography>
            <div className="mt-2">
              {siteOptions.map((site) => (
                <div key={site} className="inlineFlex" style={{ display: "inline-block", margin: "10px 10px 0 0" }}>
                  <input
                    type="checkbox"
                    className="btn-check"
                    id={site}
                    value={site}
                    onClick={handleCheckboxChange}
                    autoComplete="off"
                  />
                  <label className="btn btn-outline-primary" htmlFor={site}>
                    {site}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-4">
            <ThemeProvider theme={theme}>
              {isUpdateMode ? (
                <>
                  <Button variant="contained" onClick={handleUpdate}>Update User</Button>
                  <Button variant="contained" color="secondary" onClick={clearForm} sx={{ ml: 2 }}>
                    Clear
                  </Button>
                </>
              ) : (
                <Button variant="contained" color="success" onClick={handleSubmit}>
                  Add User
                </Button>
              )}
            </ThemeProvider>
          </div>
        </div>
      </Box>
    </Box>
  );
}

export default InviteUsers;
